//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex'
import { orderList } from '@/service/index'

import OrderMb from '@/components/order/OrderMb.vue'

export default {
  data () {
    return {
      activeName: 'first',
      orderList: []
    }
  },
  components: {
    OrderMb
  },
  mounted () {
    this.keepLang()
    this.getOrderList()
    this.activeName = this.$route.params.orderType
  },
  computed: {
    getNoPaiedOrder () {
      return this.orderList.filter(order => order.status === 1)
    },
    getPaiedOrder () {
      return this.orderList.filter(order => order.status === 2)
    }
  },
  methods: {
    async getOrderList () {
      const res = await orderList(this.$route.query.cid)
      if (res.status === 0) {
        this.orderList = res.data
      }
    },
    keepLang(){
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/my/OrderMb.vue